import { Injectable } from '@angular/core';
import { ServerBaseService } from '../server-base.service';
import { HttpClient } from '@angular/common/http';
import { ADMIN_API_SERVER_URL } from '../tokens/admin-api-server-url.token';
import { Inject } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';
import { FinanceStatus } from '@equipmyschool/emsadminweb-models';

@Injectable({
  providedIn: 'root'
})
export class FinanceStatusService extends ServerBaseService {
  private _id$ = new BehaviorSubject<number>(null);
  private id$ = this._id$.asObservable();
  private _financeStatuses$ = new BehaviorSubject<FinanceStatus[]>([]);
  private financeStatuses$ = this._financeStatuses$.asObservable();

  public financeStatus$: Observable<FinanceStatus> = combineLatest([this.financeStatuses$, this.id$]).pipe(map(([financeStatuses, id]) => financeStatuses.find(financeStatus => financeStatus.FinanceStatusID == id)));

  constructor(http: HttpClient, @Inject(ADMIN_API_SERVER_URL) serverUrl: string) {
    super(http, serverUrl)

    this.request<FinanceStatus[]>('GET', 'FinanceStatus/Get').subscribe({
      next: (financeStatuses => this._financeStatuses$.next(financeStatuses))
    });
  }

  public getFinanceStatus(financeStatusId: number) {
    this._id$.next(financeStatusId);
  }
}
